import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Spinner } from '@wartek-id/spinner'

import { SourceUploadDialogPage } from 'types/kinerja'
import useBuktiKarya from 'app/KinerjaPage/pages/UploadBuktiDukung/hooks/useBuktiKarya'

import type {
  SourceUploadDialogPageBaseProps,
  BuktiKaryaCategory,
} from 'types/kinerja'

interface SourceUploadDialogPage2Props
  extends SourceUploadDialogPageBaseProps<BuktiKaryaCategory> {}

export default function Page2({
  onSetPage = () => {},
}: SourceUploadDialogPage2Props) {
  const { isLoading, categories, total } = useBuktiKarya()

  const chooseCategory = (categoryKey) => {
    onSetPage(SourceUploadDialogPage.BUKTI_KARYA_DOCUMENT_LIST, categoryKey)
  }

  return (
    <>
      <div className="flex gap-[6px]">
        <Icon onClick={() => onSetPage(SourceUploadDialogPage.HOME)}>
          arrow_back
        </Icon>

        <div>
          <Text variant="heading-sm">Pilih</Text>
          <Text variant="body" color="subdued">
            Total {total} Dokumen (PDF)
          </Text>
        </div>
      </div>

      {isLoading ? (
        <div
          data-testid="loading-spinner-buktikarya"
          className="flex justify-center p-10"
        >
          <Spinner />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {categories.map((category) => (
            <Button
              aria-label={category.name}
              data-testid="btn-bukti-karya-category"
              disabled={category.total === 0}
              className="!justify-start"
              color="white"
              key={category.key}
              onClick={() => chooseCategory(category)}
            >
              <div className="flex items-center p-3 gap-4">
                <Icon>{category.iconName}</Icon>

                <div className="flex flex-col items-start">
                  <Text variant="body-bold">{category.name}</Text>
                  <Text color="subdued">{category.total} Dokumen</Text>
                </div>
              </div>
            </Button>
          ))}
        </div>
      )}
    </>
  )
}
